export default {
  data: () => ({
    validateFunctionId: Math.random() + ''
  }),

  mounted() {
    // Список Ref инпутов для разных типов виджета
    const listOfRefsByType = {
      'dr-text-field': 'drTextFieldRef',
      'dr-checkbox': 'drCheckboxRef',
      'dr-autocomplete-elem': 'drAutocompleteElemRef',
      'dr-combo-box': 'drComboBoxRef',
      'dr-drop-down': 'drDropDownRef'
    }

    // Если у нас есть дата виджет и виджет Required, сохранить дата виджету метод валидации свойства Required
    // Только в режиме проигрывания
    if (this.parentDataWidget && this._isRequiredField && !this.isInEditorMode) {
      this.parentDataWidget.validateFieldsFunctions.push({
        id: this.validateFunctionId,
        validate: () => {
          return this.$refs?.[listOfRefsByType[this.model?.$Type]]?.validate(!0)
        }
      })
    }
  },

  beforeDestroy() {
    // Удаления метода валидации по id из дата виджета, чтобы не копились ненужные методы.
    // Только в режиме проигрывания
    if (!this.isInEditorMode) {
      const indexValidateFunction = this.parentDataWidget?.validateFieldsFunctions?.findIndex((e) => e.id === this.validateFunctionId)
      this.parentDataWidget?.validateFieldsFunctions?.splice(indexValidateFunction, 1)
    }
  }
}